<template>
    <div class="articleEdit">
        <!-- 提示 -->
        <el-alert :title="alertData[0].title" type="warning" show-icon></el-alert>
        <!-- 发布的内容 -->
        <div class="issueContent">
            <div class="articleForm form">
                <el-form :model="articleData" :rules="rules" ref="articleData" label-width="110px" class="demo-item" label-position="left" size="mini">
                    <div class="title">| <span>基本信息</span></div>
                    <el-form-item label="图文名称" prop="articlename">
                        <el-input v-model.trim="articleData.articlename" placeholder="请输入图文名称，不超过45个字" clearable maxlength="45" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="图文封面" prop="coverPicture" class="upload-image">
                        <upload class="headImage" :imgRule="imgRule" ref="coverfile" :uploadType="uploadType" @setImage="getImageUrl"></upload>
                        <p class="tips">建议尺寸750*560px或4：3，JPG、PNG格式， 图片小于5M。</p>
                    </el-form-item>
                    <el-form-item label="图文详情" prop="despfee">
                        <div class="ueditorBox">
                            <uEditor :content="articleData.despfee" ref="uEditor" @getUEditorContent="getMsgContent"></uEditor>
                        </div>
                    </el-form-item>
                    <el-form-item label="试看内容">
                        <div class="ueditorBox">
                            <uEditor :content="articleData.desptry" ref="uEditor2" @getUEditorContent="getTrySeeContent"></uEditor>
                        </div>
                    </el-form-item>
                    <el-form-item label="文字防复制">
                        <el-radio :label="0" v-model="articleData.istextcopy">允许复制</el-radio>
                        <p class="radioTips">商品的文字内容允许复制，图片点击放大和长按识别二维码功能允许使用</p>
                        <el-radio :label="1" v-model="articleData.istextcopy">禁止复制</el-radio>
                        <p class="radioTips">商品的文字内容禁止复制，图片点击放大和长按识别二维码功能不允许使用</p>
                    </el-form-item>
                    <div class="title">| <span>商品信息</span></div>
                    <el-form-item label="售卖方式">
                            <PromotionMsg ref="promotionMsg" @changeWay="changeWay"></PromotionMsg>
                    </el-form-item>
                    <el-form-item label="图文展示方式" class="showWay">
                        <el-radio-group v-model="articleData.detaildisplaytype">
                            <el-radio :label="1">商品模式</el-radio>
                            <el-radio :label="2">文章模式 (仅限纯免费)</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="商品分组" class="commodityGroup">
                        <el-select v-model="articleData.divisionids" collapse-tags multiple clearable>
                             <el-option v-for="item in goodsGroup" :label="item.name" :key="item.innerid" :value="item.innerid"></el-option>
                        </el-select>
                        <span class="refresh" @click="refresh">刷新</span>
                        <span class="goCommodityGroup" @click="goGoodsGroup">前往商品分组</span>
                        <p class="groupTips">商品分组可辅助你更好地管理商品</p>
                    </el-form-item>
                    <div class="title">| <span>上架设置</span></div>
                    <el-form-item label="上架方式" prop="onLineType" class="onlineWay">
                        <!--<el-radio :label="1" v-model="articleData.onlinetype">立即上架</el-radio><br>-->
                        <!--<el-radio :label="2" v-model="articleData.onlinetype">定时上架</el-radio>-->
                        <!--<el-date-picker placeholder='请选择定时上架时间' v-model.trim="articleData.onlinetime" value-format="yyyy-MM-dd HH:mm:ss" :disabled="String(articleData.onlinetype) !== '2'"  type="datetime"></el-date-picker><br/>-->
                        <!--<el-radio :label="3" v-model="articleData.onlinetype">暂不上架</el-radio>-->
                        <shalfSetting :item="articleData"></shalfSetting>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('articleData')" :disabled="submitBtn">提交</el-button>
                        <el-button type="" @click="cancel">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div >
</template>
<script>
import Upload from 'base/upload/upload'
import UEditor from 'base/uEditor/uEditor'
import PromotionMsg from 'base/promotionMsg/promotionMsg'
import {newArticleMsg, editArticleMsg, getArticleInfo, commodityGroup} from '@/api/imageText'
import {formatCheckList, formatCheckView, formatFileInfo} from '@/common/js/tools'
import {mapGetters, mapActions} from 'vuex'
import ShalfSetting from 'base/promotionMsg/shalfSetting'
import $ from 'jquery'
export default {
    name: 'articleEdit',
    data() {
        // 检查上架方式
        let checkOnlineType = (rule, value, callback) => {
            if (!this.articleData.onlinetype) {
                callback(new Error('请选择上架方式'))
            } else if (this.articleData.onlinetype === 2) {
                if (!this.articleData.onlinetime) {
                    callback(new Error('请选择时间'))
                } else {
                    callback()
                }
            } else {
                if (String(this.articleData.onlinetype) !== 2) {
                    this.articleData.onlinetime = ''
                }
                callback()
            }
        }
        // 检查图文封面
        let validateCoverPicture = (rule, value, callback) => {
            if (!value.furl) {
                callback(new Error('请选择图文封面'))
            } else {
                callback()
            }
        }
        return {
            alertData: [
                {title: '请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容。所有投稿资鲸平台的原创稿件，资鲸官方均有权对内容细节或标题进行调整，如果需要对稿件做重大调整，编辑会与作者联系确认。'}
            ],
            articleData: {
                innerid: this.$route.query.innerid ? this.$route.query.innerid : '', // id
                articlename: '', // 图文名称
                despfee: '', // 图文详情
                desptry: '', // 试看内容
                istextcopy: 0, // 是否允许复制
                onlinetype: 1, // 上架方式
                onlinetime: '', // 定时时间
                divisionids: [],
                detaildisplaytype: 1,
                isplatform: true,
                ispublic: true,
                coverPicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                }
            },
            feetype: 1,
            goodsGroup: [],
            submitBtn: false, // 提交按钮是否禁用
            timeArr: [
                '1', '6', '12', '24', '72', '168', '672'
            ],
            rules: {
                articlename: [
                    {required: true, message: '请输入图文名称', trigger: 'blur'},
                    {min: 1, max: 45, message: '长度在 1 到 45 个字符', trigger: 'blur'}
                ],
                despfee: [
                    {required: true, message: '请输入图文详情', trigger: 'blur'}
                ],
                onLineType: [
                    {validator: checkOnlineType, trigger: 'blur'}
                ],
                coverPicture: [
                    {validator: validateCoverPicture, trigger: 'blur'}
                ]
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 2,
                width: 100,
                height: 100
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE',
                attid: '',
                url: ''
            },
            changeFeetype: 0,
            sellWayFormData: {
                item: null
            }
        }
    },
    created() {
    },
    mounted() {
        if (this.articleData.innerid) {
            this.getArticleInfoId(this.articleData.innerid)
        }
        this.getCommodityGroup()
    },
    methods: {
        handleOpenGallery() {
            this.$refs.gallery.openDialog(this.item)
        },
        // 图文详情
        getMsgContent(content) {
            this.articleData.despfee = content
        },
        // 试看内容
        getTrySeeContent(content) {
            this.articleData.desptry = content
        },
        submitForm(formName) {
            this.$refs.promotionMsg.$refs.sellWayForm.validate((v) => {
                this.$refs[formName].validate((valid) => {
                    if (valid && v) {
                        this.$confirm('请确认您的输入信息是否完整正确？', '提交内容', {
                            cancelButtonText: '取消',
                            confirmButtonText: '确定',
                            closeOnClickModal: false
                        }).then(() => {
                            let tmpList = formatCheckList(JSON.parse(JSON.stringify(this.$refs.promotionMsg.item.checkView)))
                            let obj = $.extend(true, {}, Object.assign({}, this.articleData, this.$refs.promotionMsg.item))
                            obj.checkView = JSON.stringify(tmpList)
                            obj.coverPicture = formatFileInfo(obj.coverPicture)
                            obj.divisionids = obj.divisionids.join(',')
                            obj.isplatform = obj.isplatform ? 1 : 0
                            obj.ispublic = obj.ispublic ? 1 : 0
                            if (this.articleData.innerid) {
                                this.updateArticleMsg(obj)
                            } else {
                                this.addArticelMsg(obj)
                            }
                        }).catch(() => {
                            this.submitBtn = false
                        })
                    } else {
                        this.submitBtn = false
                        this.$message.error('请完善您的数据！')
                        return false
                    }
                })
            })
        },
        addArticelMsg(obj) {
            this.setLoading(true)
            newArticleMsg({
                data: obj,
                success: data => {
                    if (data.code === '000') {
                        this.setLoading(false)
                        this.$message({
                            type: 'success',
                            message: '保存成功'
                        })
                        this.$router.push({path: '/cms/article/articleList', query: {refresh: '1'}})
                    } else {
                        this.setLoading(false)
                        this.$message.error('保存失败')
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        updateArticleMsg(obj) {
            this.setLoading(true)
            editArticleMsg({
                data: obj,
                success: data => {
                    if (data.code === '000') {
                        this.setLoading(false)
                        this.$message({
                            type: 'success',
                            message: '保存成功'
                        })
                        this.$router.push({path: '/cms/article/articleList', query: {refresh: '0'}})
                    } else {
                        this.setLoading(false)
                        this.$message.error('保存失败')
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        cancel() {
            this.$router.push({name: 'ArticleList'})
        },
        getImageUrl(img) {
            this.articleData.coverPicture = img
        },
        freeOrNofree() {
            if (this.articleData.checkView.feetype === '2') {
                this.articleData.checkView.share.status = false
            }
        },
        // 获取单个图文数据
        getArticleInfoId(innerid) {
            this.setLoading(true)
            getArticleInfo({
                data: {innerid},
                success: data => {
                    this.setLoading(false)
                    data.data.checkView = formatCheckView(JSON.parse(data.data.checkView), this.$refs.promotionMsg.item.checkView)
                    this.articleData = data.data
                    this.articleData.coverPicture = JSON.parse(this.articleData.coverPicture)
                    this.articleData.innerid = innerid
                    this.feetype = data.data.feetype
                    // 售卖设置信息
                    this.$refs.promotionMsg.setItem(this.articleData)
                    // 试看内容信息
                    this.$refs.uEditor2.init(this.articleData.desptry)
                    // 详情信息
                    this.$refs.uEditor.init(this.articleData.despfee)
                    // 图片封面
                    this.uploadType.attid = data.data.coverPicture.key
                    this.uploadType.url = data.data.coverPicture.furl
                    this.articleData.isplatform = this.articleData.isplatform === 1
                    this.articleData.ispublic = this.articleData.ispublic === 1
                    this.$refs.coverfile.setImage(this.articleData.coverPicture.furl)
                    if (this.articleData.covertpurl) {
                        this.$refs.covertpfile.setImage(this.articleData.covertpurl)
                    }
                    this.getCommodityGroup()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        getCommodityGroup() {
            let obj = {
                totalcount: String(this.feetype)
            }
            this.setLoading(true)
            commodityGroup({
                data: {},
                success: data => {
                    this.goodsGroup = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 前往商品分组
        goGoodsGroup() {
            let goPath = window.location.origin + '/shopMgt/goods/goodsGroup'
            window.open(goPath)
        },
        ...mapActions([
            'setLoading'
        ]),
        refresh() {
            this.getCommodityGroup()
        },
        changeWay(type) {
            this.feetype = type
        }
    },
    components: {
        Upload,
        UEditor,
        PromotionMsg,
        ShalfSetting
    },
    watch: {
        'articleData.detaildisplaytype': {
            handler(newV) {
                if (newV === 2) {
                    if (this.feetype === 1) {
                        return
                    } else {
                        this.articleData.detaildisplaytype = 1
                    }
                }
            }
        },
        'feetype': {
            handler(newV) {
                if (newV === 2) {
                    this.articleData.detaildisplaytype = 1
                }
            }
        },
        deep: true
    },
    computed: {
        ...mapGetters([
            'loading',
            'user',
            'permission'
        ])
    }
}
</script>
<style lang="scss">
@import "~common/scss/mixin";
@import "~common/scss/base";
.articleEdit{
    .el-alert{
        height: 44px;
    }
    .issueContent{
        margin-top: 20px;
        .title{
            color: #409EFF;
            font-size: 16px;
            margin-bottom: 20px;
            span{
                color: #303133;
                font-weight: 700;
                position: relative;
                top: 2px;
            }
        }
        .articleForm{
            margin-top: 10px;
            width: 925px;
            .upload-image{
                .el-form-item__label::after{
                    content: "*";
                    color: #F56C6C;
                    margin-left: 4px;
                }
                .el-form-item__content{
                    @include flexBox('');
                    .tips{
                        margin-left: 22px;
                        color: #C0C4CC;
                    }
                }
            }
            .headImage .avatar-uploader{
                box-sizing: border-box;
                width: 320px;
                height: 180px;
            }
            .original{
                color: #606266;
                font-size: 12px;
            }
            .radioTips{
                padding-left: 24px;
                color: #606266;
            }
            .showWay{
                .el-radio{
                    margin-right: 50px;
                }
            }
            .commodityGroup{
                .refresh{
                    color: #409EFF;
                    margin-left: 18px;
                    cursor: pointer;
                }
                .goCommodityGroup{
                    margin-left: 22px;
                    cursor: pointer;
                    color: #409EFF;
                }
                .groupTips{
                    font-size: 14px;
                    color: #909399;
                }
                .el-select{
                    width: 368px;
                }
            }
            .onlineWay{
                .el-form-item__label::after{
                    content: "*";
                    color: #F56C6C;
                    margin-left: 4px;
                }
            }
            .el-radio__input.is-checked+.el-radio__label{
                color: #303133;
            }
        }
    }
}
</style>
